import script from "./ListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ListTable.vue?vue&type=script&setup=true&lang=js"

import "./ListTable.vue?vue&type=style&index=0&id=70d39c8b&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d39c8b"]])

export default __exports__